<template>
  <div class="table">
    <el-row>
      <el-switch style="display: block" v-model="options" @change="optionsChange" active-color="#409EFF" inactive-color="#E7E7E7" active-text="Facility" inactive-text="结算单位"></el-switch>
    </el-row>
    <el-row v-if="tags.length>0">
      <p style="padding: 5px 10px 0 10px;">已选择的{{!options?"结算单位":"Facility"}}</p>
    </el-row>
    <div class="container" v-if="tags.length>0">
      <div class="handle-box">
        <div class="tag_dv">
          <div class="tag_dv_children" v-for="tag in tags" :key="tag.supplierCode" style="margin-bottom:10px">
            <el-tag closable @close="handleClose(tag)">
              {{tag.supplierName}}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="supplierForm" ref="supplierForm" label-position="right" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="结算单位名称" prop="supplierName">
                <el-input v-model="supplierForm.supplierName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结算单位英文名称" prop="supplierNameEn">
                <el-input v-model="supplierForm.supplierNameEn" @blur="getAslName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility中文名称" prop="plantName" v-if="options">
                <el-input v-model="supplierForm.plantName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="Facility英文名称" prop="plantNameEn" v-if="options">
                <el-input v-model="supplierForm.plantNameEn" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          </el-row>
        </el-form>
      </div>
      <!-- 结算单位选择 -->
      <el-row class="action-btn-row" v-if="!options">
        <el-button size="small" class="btn" type="primary" @click="onSelSupplier">添加</el-button>
        <el-button size="small" class="btn" type="primary" @click="onConfirmSupplier">确认</el-button>
      </el-row>
      <!-- facility选择 -->
      <el-row class="action-btn-row" v-if="options">
        <el-button size="small" class="btn" type="primary" @click="onSelPlant">添加</el-button>
        <el-button size="small" class="btn" type="primary" @click="onConfirmPlant">确认</el-button>
      </el-row>
      <el-table v-if="!options" ref="multipleTable1" :data="supplierData" @selection-change="selectionChange1" max-height="400" border stripe highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="结算单位名称" min-width="100" prop="supplierName"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="结算单位英文名称" min-width="90" prop="supplierNameEn"></el-table-column>
      </el-table>
      <el-table v-if="options" ref="multipleTable2" :data="facilityData" @selection-change="selectionChange2" max-height="400" border stripe highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="结算单位名称" min-width="100" prop="supplierName"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="结算单位英文名称" min-width="90" prop="supplierNameEn"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="Facility中文名称" min-width="90" prop="plantName"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip label="Facility英文名称" min-width="120" prop="plantNameEn"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import rmcProtPurchaseApi from "@/api/rmcProtein/purchase";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";

export default {
  name: 'rmcProtPurchase',
  mixins: [paginationMixin],
  props: ['data'],
  components: {
    IcSelect,
  },
  data() {
    return {
      supplierData: [],//结算单位列表
      facilityData: [],//facility列表
      ms_Permission: [],
      multipleSelection1: [],//结算单位选中的数据
      multipleSelection2: [],//facility选中的数据
      selectionSupplierCodeLists: [],//存放结算单位选中的supplierCode
      selectionPlantCodeLists: [],//存放facility选中的plantCode
      tags: [],
      supplierCode_data_list: [],//原始存在的结算单位list
      facility_data_list: [],//原始存在的facility list
      original_table: [],//原始存在的结算单位和facility数据
      supplierCode_data: [],//原始存在的结算单位code
      facility_data: [],//原始存在的facility Code

      add_original_supplier: [],//通过原始的label筛选出数据
      add_original_facility: [],//通过原始的label筛选出数据
      supplierForm: {
        pageSize: 15,
        pageNum: 1,
        supplierName: "",
        supplierNameEn: "",
        plantName: "",
        plantNameEn: "",
      },
      options: false,//false为结算单位,true为facility
      totalCount: 0,
      pages: 1,
    }
  },
  watch: {
    data: {
      handler(newV, oldV) {
        console.log('获取原始的结算单位以及facility', newV);
        if (newV) {
          this.original_table = JSON.parse(newV)
          this.original_table.forEach(ele => {
            if (ele.type === 0) {
              this.supplierCode_data.push(ele.supplierCode)
              this.supplierCode_data_list.push(ele)
              this.tags.push(ele)
            }
            if (ele.type === 1) {
              this.facility_data.push(ele.supplierCode)
              this.facility_data_list.push(ele)
            }
          })
          console.log('original_table', this.original_table);
          console.log('supplierCode_data', this.supplierCode_data);
          console.log('facility_data', this.facility_data);
          console.log('supplierCode_data_list', this.supplierCode_data_list);
          console.log('facility_data_list', this.facility_data_list);
        }
      },
      immediate: true
    }
  },
  created() {
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
    this.$nextTick(() => {
      this.queryData1()
      this.queryData2()
    })
  },
  methods: {
    // 获取结算单位列表
    queryData1() {
      rmcProtPurchaseApi.findSupplier({
        supplierName: this.supplierForm.supplierName,
        supplierNameEn: this.supplierForm.supplierNameEn
      }).then(res => {
        console.log('获取结算单位列表', res);
        this.supplierData = res;
      });
    },
    // 获取facility列表
    queryData2() {
      rmcProtPurchaseApi.findFacility(this.supplierForm).then(res => {
        console.log('获取facility列表', res);
        this.facilityData = res;
      });
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    optionsChange(val) {
      console.log('this.supplierCode_data_list', this.supplierCode_data_list);
      console.log('this.facility_data_list1', this.facility_data_list);
      if (val) {
        this.tags = [...this.facility_data_list]
        this.queryData2()
      } else {
        this.tags = [...this.supplierCode_data_list]
        this.queryData1()
      }
    },
    // 去重
    fun(arr) {
      let s1 = new Set(arr);
      return [...s1];
    },
    // 获取结算单位选中的数据
    selectionChange1(val) {
      console.log('选中的数据1', val);
      this.selectionSupplierCodeLists = []
      this.multipleSelection1 = val;
      val.forEach(ele => {
        this.selectionSupplierCodeLists.push({
          supplierCode: ele.supplierCode,
          supplierName: ele.supplierName,
        })
      })
    },
    // 结算单位选择确认
    onSelSupplier() {
      console.log('获取选中的数据', this.multipleSelection1);
      for (let ele of this.multipleSelection1) {
        // 如果有相同的值那么就返回对应的对象 如果没有则返回 undefined
        const itemJson = this.tags.find((item) => { return item.supplierCode === ele.supplierCode });
        console.log('itemJson', itemJson)
        if (itemJson) {
          this.$message.error(itemJson.supplierName + '已存在,请勿重复添加!')
          return
        }
      }
      // 如果facility列表存在并且原始facility Code存在
      if (this.facilityData && this.facility_data) {
        //已经存在的facility所对应的结算单位
        var tempData = this.facilityData.filter(ele => {
          return this.facility_data.includes(ele.plantCode)
        }).map(el => {
          return el.supplierCode
        })
        tempData = this.fun(tempData)
        console.log('tempData', tempData);
        //如果选中的结算单位已经存在,则不可以重复选择
        var flag = false
        if (this.selectionSupplierCodeLists.length > 0) {
          for (let i = 0; i < this.selectionSupplierCodeLists.length; i++) {
            var ele = this.selectionSupplierCodeLists[i]
            if (tempData.includes(ele.supplierCode)) {
              this.$message.error(ele.supplierName + '供应商选择重复，无法添加.')
              flag = true
            }
          }
        }
        if (!flag) {
          this.tags = this.tags.concat(this.multipleSelection1)
          this.$refs.multipleTable1.clearSelection();
        }
      }
      console.log('tags', this.tags);
    },
    onConfirmSupplier() {
      console.log('tags', this.tags);
      console.log('facility_data_list', this.facility_data_list);
      var flag = false
      var length1 = this.tags.length
      var length2 = this.facility_data_list.length
      var length = Number(length1) + Number(length2)
      console.log('length1', length1);
      console.log('length2', length2);
      console.log('length', length);
      if (length > 20) {
        this.$message.error('最多选择20家供应商伙伴')
        flag = true
      }
      if (!flag) {
        this.$emit('setSupplier', JSON.stringify(this.tags))
      }
    },
    // 获取facility选中的数据
    selectionChange2(val) {
      this.multipleSelection2 = val;
    },
    onSelPlant() {
      console.log('获取选中的数据2', this.multipleSelection2);
      for (let ele of this.multipleSelection2) {
        // 如果有相同的值那么就返回对应的对象 如果没有则返回 undefined
        const itemJson = this.tags.find((item) => { return item.supplierCode === ele.plantCode });
        console.log('itemJson', itemJson)
        if (itemJson) {
          this.$message.error(itemJson.supplierName + '已存在,请勿重复添加!')
          return
        }
      }
      var flag = false
      if (this.multipleSelection2.length > 0) {
        for (let i = 0; i < this.multipleSelection2.length; i++) {
          var ele = this.multipleSelection2[i]
          if (this.supplierCode_data.includes(ele.supplierCode)) {
            // this.$message.error(ele.supplierName + '供应商选择重复，无法添加.')
            this.$message.error(ele.supplierName + '供应商选择重复，无法添加.')
            flag = true
          }
        }
      }
      if (!flag) {
        if (this.multipleSelection2.length > 0) {
          var format_arr = []
          this.multipleSelection2.forEach(ele => {
            format_arr.push({
              aslName: null,
              purchaseQuantity: null,
              supplierCode: ele.plantCode,
              supplierName: ele.plantName,
              type: 1,
            })
          })
        }
        this.tags = this.tags.concat(format_arr)
        this.$refs.multipleTable2.clearSelection();
      }
      console.log('tags', this.tags);
    },
    onConfirmPlant() {
      console.log('tags', this.tags);
      console.log('supplierCode_data_list', this.supplierCode_data_list);
      var flag = false
      var length1 = this.tags.length
      var length2 = this.supplierCode_data_list.length
      var length = Number(length1) + Number(length2)
      console.log('length1', length1);
      console.log('length2', length2);
      console.log('length', length);
      if (length > 20) {
        this.$message.error('最多选择20家供应商伙伴')
        flag = true
      }
      if (!flag) {
        this.$emit('setFacility', JSON.stringify(this.tags))
      }
    },
    onSearch() {
      if (!this.options) {
        this.queryData1()
      } else {
        this.queryData2()
      }
    },
    onReset() {
      this.$refs['supplierForm'].resetFields()
      this.supplierForm = {
        pageSize: 15,
        pageNum: 1,
        supplierName: "",
        supplierNameEn: "",
        plantName: "",
        plantNameEn: "",
      }
      if (!this.options) {
        this.queryData1()
      } else {
        this.queryData2()
      }
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
